'use strict';

var styled = require('styled-components');
var index = require('../Flex/index.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const Container = styled__default.default.div `
  position: relative;
  display: inline-block;
  font-family: ${({ theme }) => theme.designTokens.filterFontFamily};
`;
const Count = styled__default.default.span `
  position: absolute;
  right: 0;
  top: -12px;
  z-index: 1;
  background-color: ${({ theme }) => theme.colors.primary.normal};
  color: ${({ theme }) => theme.colors.body.textLight};
  border: solid 1px ${({ theme }) => theme.colors.body.textLight};
  height: ${({ theme }) => theme.space.component.y.l};
  width: ${({ theme }) => theme.space.component.y.l};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${({ theme }) => theme.typography.fontSize.xs};
  font-weight: 600;
`;
const DropdownItemContainer = styled__default.default.div `
  min-width: 250px;
  padding: ${({ theme }) => theme.space.component.y.m} ${({ theme }) => theme.space.component.y.l};
`;
const DropdownItemContainerWithoutButtons = styled__default.default.div `
  min-width: fix-content;
`;
const ButtonContainer = styled__default.default(index.Flex.Row) `
  padding-top: ${({ theme }) => theme.space.component.y.l};
`;
const Styled = {
    ButtonContainer,
    Container,
    Count,
    DropdownItemContainer,
    DropdownItemContainerWithoutButtons,
};

exports.Styled = Styled;
//# sourceMappingURL=styles.js.map
